<template>
  <div style="width: 100%;" id="forgotPwd">
    <div class="container main-container hidden-sm-and-down">
      <div class="imgbox">
        <h1 class="title">忘记密码</h1>
        <span class="title_a">请输入您的手机号以重置您的密码，稍后您会收到一则短信验证码</span>
      </div>
      <div class="pc">
        <div class="containers">
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="手机号码" prop="tel">
              <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" type="phone" v-model="ruleForm.tel" autocomplete="off" placeholder="请输入手机号" ref="phone"></el-input>
            </el-form-item>
            <el-form-item label="短信验证码" prop="telcode">
              <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" style="width: 65%;float: left" type="telcode" label-width="80px" v-model="ruleForm.telcode" autocomplete="off" ref="phonecode"></el-input>
              <el-button class="" style="width: auto;height: 41px;background:#00383F;border-radius:5px;color: #fff;padding-left: 15px; padding-right: 15px;" @click="send">
                <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
                <span v-if="!sendMsgDisabled">获取验证码</span>
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button class="btn" @click="submit()">继续</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 手机端显示 -->
    <div class="hidden-md-and-up mob">
        <div class="imgbox">
          <h1>忘记密码</h1>
          <p>请输入您的手机号以重置您的密码<br>稍后您会收到一则短信验证码</p>
      </div>
       <div class="containers">
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item  prop="tel">
              <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" type="phone" v-model="ruleForm.tel" autocomplete="off" placeholder="手机号码" ref="phone"></el-input>
            </el-form-item>
            <el-form-item prop="telcode">
              <el-input placeholder="请输入短信验证码" onkeyup="this.value=this.value.replace(/\D+/g,'')" style="width: 65%;float: left" type="telcode" label-width="80px" v-model="ruleForm.telcode" autocomplete="off" ref="phonecode"></el-input>
              <el-button class="" style="width: 2rem;height: 0.83rem;background:#00383F;border-radius:unset;color: #fff;font-size:0.24rem;float:right" @click="send">
                <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
                <span v-if="!sendMsgDisabled">获取验证码</span>
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button class="btn" @click="submit()">继续</el-button>
            </el-form-item>
          </el-form>
        </div>
    </div>
  </div>
</template>
<script>
  import {forgetAPI,send_code_API} from '../request/api'

  export default {
    name: "forgotpassword",
    data() {
      let checkTel = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else {
          const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      };
      return {
        time: '60',
        sendMsgDisabled: false,
        ruleForm: {
          tel: '',
          telcode:''
        },
        rules: {
          tel: [
            {validator: checkTel, trigger: 'blur'}
          ],
          telcode: [
            {required: true, message: '验证码不可为空', trigger: 'blur'},
            { min: 6, max: 6, message: '验证码为6位数字', trigger: 'blur' }
          ],
        }
      };
    },
    methods: {
     submit() {
        let postParams = {
          "phone": this.$refs.phone.value,
          "code": this.$refs.phonecode.value,
        };
        if (this.$refs.phone.value === '' || this.$refs.phonecode.value === '') {
         this.$message.error('请输入完整信息');
          return false
        }
        forgetAPI(postParams).then((res)=>{
          console.log(res)
            if (res.data.code === 100) {
                this.$message.error('短信验证码不正确');
                }
                if (res.data.code === 200) {
                    let token = res.data.data.token;
                    //请求成功保存用户登录信息到localStorage和Vuex中
                    localStorage.setItem('userToken', token);
                    this.$cookies.set('tokenDate', new Date().getTime(),3600);
                    this.$store.dispatch('setLogin', token);
                    this.$message.success('继续重置密码');
                    this.$router.push({path: '/resetpwd'});
                }
        })
      },
      // 获取验证码
        send() {
        let userInfo = {
          'phone': this.$refs.phone.value,
          'lostatus': 'reset'
        };
        let _self = this;
        let phone = this.$refs.phone.value;
        let reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
        if (phone !== ''&& reg.test(phone)) {
        send_code_API(userInfo).then((res)=>{
          console.log(res.data.message)
          if (res.data.code === 100) {
           this.$message.error(res.data.message);
          }
          if (res.data.code === 200) {
            this.$message.success('验证码发送成功');
            _self.sendMsgDisabled = true;
            let interval = window.setInterval(function () {
              if ((_self.time--) <= 0) {
                _self.time = 60;
                _self.sendMsgDisabled = false;
                window.clearInterval(interval);
              }
            }, 1000);
          }
        })
        } else {
          this.$message.error('请输入手机号');
          _self.sendMsgDisabled = false;
          return false
        }
      }
    },
  };
</script>
<style lang="less" scoped>

 .container{
     width: 100%;
     color: #00383F;
     .imgbox{
             width: 60%;
            margin: 0 auto;
            padding-top: 165px;
            h1{
                padding: 2% 0;
            }
            span{
                    display: block;
                    font-size: 18px;
                    margin-bottom: 60px;
            }
     }
     .pc{
         width: 100%;
        margin: 0 auto;
        padding-bottom: 150px;
        .containers{
            max-width: 600px;
            margin: 0 auto;
            .demo-ruleForm{
                width: 70%;
                margin: 0 auto;
            }
            .btn{
                width: 135px;
                height: 40px;
                float: left;
                margin-top: 30px;
                margin-left: 20%;
                background: #00383F;
                color: #fff;
            }
        }
     }
 }
 @media (max-width: 991px) {
   .mob{
     margin: 0 0.6rem;
      color: #00383F;
      padding-bottom: 3rem;
     .imgbox{
       h1{
         font-weight: 900;
          line-height: 32px;
          font-size: 0.4rem;
          margin-top: 1rem;
       }
       p{
         font-size: 0.3rem;
         margin: 0.3rem 0 0.59rem 0;
       }
     }
     .btn{
       width: 100%;
       background: #00383F;
        border: 1px solid #00383F;
        height: 0.89rem;
        font-weight: 900;
        color: #F8FFFF;
        font-size: 0.33rem;
        border-radius: unset;
     }
   }
   /deep/.el-input__inner::placeholder{
     text-align: left;
     font-size: 0.24rem;
   }
   /deep/.el-input__inner{
     height: 0.83rem;
     border-radius: unset;
   }
   /deep/.el-button{
     padding: unset;
   }
 }
</style>



// WEBPACK FOOTER //
// src/view/ForgotPwd.vue